// Copyright (c) 2015, LucrumERP Pvt. Ltd. and Contributors
// MIT License. See license.txt

// provide a namespace
if (!window.ducky) window.ducky = {};

ducky.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

ducky.provide("locals");
ducky.provide("ducky.flags");
ducky.provide("ducky.settings");
ducky.provide("ducky.utils");
ducky.provide("ducky.ui.form");
ducky.provide("ducky.modules");
ducky.provide("ducky.templates");
ducky.provide("ducky.test_data");
ducky.provide("ducky.utils");
ducky.provide("ducky.model");
ducky.provide("ducky.user");
ducky.provide("ducky.session");
ducky.provide("ducky._messages");
ducky.provide("locals.DocType");

// for listviews
ducky.provide("ducky.listview_settings");
ducky.provide("ducky.tour");
ducky.provide("ducky.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
